import {Command} from './Command';
import {ObjectDeleteAction} from '../actions';
import {StageService} from '../../stage.service';

export class ObjectDeleteCommand extends Command<ObjectDeleteAction> {

  protected object;
  private parent;

  constructor(
    private stage: StageService
  ) {
    super();
  }

  do(action: ObjectDeleteAction) {
    const {object} = action;
    this.object = object;
    this.parent = object.parent;
    this.stage.remove(object);
  }

  undo() {
    this.stage.add(this.object, this.parent);
  }

  dispose() {
    this.object = null;
    this.parent = null;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/eventLog/commands/ObjectDeleteCommand.ts